import React from 'react'
import { useDispatch } from 'react-redux'
import { UsersSearch } from '../../components/UsersSearch'
import { createController, loadControllers } from '~/state/modules/organizers'
import { showSnackbarError } from 'views/utils/snackbar'

export const ControllerCreatePage = ({
  match,
  onSuccess: onSuccessOrganizerPage,
  onCancel
}) => {
  const dispatch = useDispatch()

  const onSuccess = async (userId) => {
    try {
      await dispatch(createController(match.params.id, userId))
      dispatch(loadControllers(match.params.id))
      onSuccessOrganizerPage(match.params.id)
    } catch (error) {
      showSnackbarError(error)
    }
  }

  return (
    <UsersSearch
      match={match}
      onSuccess={onSuccess}
      onCancel={onCancel}
      message={'Está seguro que desea agregar el Controlador de Ingreso'}
    />
  )
}

export default ControllerCreatePage
